import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-total-records',
  templateUrl: './mobile-total-records.component.html',
  styleUrls: ['./mobile-total-records.component.scss']
})
export class MobileTotalRecordsComponent implements OnInit {
  mobileBtnActive: boolean = true;

  @Input() totalRecords = 0;
  @Input() mobileLayoutDefault? = true;
  @Input() showMobileSwitch = true;
  @Output() showMobileLayoutEvent = new EventEmitter<boolean>();

  constructor() {
  }

  ngOnInit(): void {
    if(this.mobileLayoutDefault === false) {
      this.showDesktopLayout();
    }else {
      this.showMobileLayout();
    }
  }


  showMobileLayout(): void {
    this.showMobileLayoutEvent.emit(true);
    this.mobileBtnActive = true;
  }

  showDesktopLayout(): void {
    this.showMobileLayoutEvent.emit(false);
    this.mobileBtnActive = false;
  }
}
